import { ADD_FIELD_PROMPT_CONTEXT } from '@cli-constants/prompt-copy.js'
import { promptConfirm as promptSchemaConfirm } from '../schema-prompts/prompt-confirm.js'

export async function promptConfirm(message: string, initialValue = true): Promise<boolean> {
  return promptSchemaConfirm(ADD_FIELD_PROMPT_CONTEXT, message, initialValue)
}
